import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `<div class="spinner spinner_loading"></div>`,
})
export class SpinnerComponent {}
